module.exports = __webpack_public_path__ + "img/728.31d6ec12.jpg";